module.exports = [{
      plugin: require('/home/lane/Development/lanesawyer.github.io/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
